module.exports = __webpack_public_path__ + "media/images/athletes/2520-1300d3c4965e31eb8cd78fc100e16acb.png";